var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "d-flex flex-row justify-start", attrs: { flat: "" } },
        [
          _c(
            "v-col",
            { staticClass: "px-0", attrs: { sm: "5" } },
            [
              _c("v-card", { attrs: { flat: "" } }, [
                _c("h3", { staticClass: "text-subtitle-1" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
                _vm.tooltip
                  ? _c("p", { staticClass: "text-caption" }, [
                      _vm._v(_vm._s(_vm.tooltip)),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "v-card",
                { staticClass: "d-flex flex-row", attrs: { flat: "" } },
                [
                  _vm.autoAllocation
                    ? _c(
                        "v-card",
                        { staticClass: "mx-2", attrs: { flat: "" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-0",
                            attrs: { dense: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "my-auto text-caption" },
                                        [_vm._v("Auto Allocation")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              900887725
                            ),
                            model: {
                              value: _vm.autoAllocationStatus,
                              callback: function ($$v) {
                                _vm.autoAllocationStatus = $$v
                              },
                              expression: "autoAllocationStatus",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-card",
                    { staticClass: "mx-2", attrs: { flat: "" } },
                    [
                      !_vm.autoAllocation ||
                      (_vm.autoAllocation && !_vm.autoAllocationStatus)
                        ? _vm._t("constant-switch")
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card",
            { staticClass: "grow", attrs: { flat: "" } },
            [
              !_vm.autoAllocation ||
              !(_vm.autoAllocation && _vm.autoAllocationStatus)
                ? _vm._t("default")
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }